(() => {
  if (customElements.get('cm-leather-pickup')) return;

  // Match the Liquid fallback: an epoch day in Japan, independent of the visitor's timezone.
  const DAY = 86400000;
  const JST = 9 * 60 * 60 * 1000;

  class LeatherPickup extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-leather-grid]');
      this.panels = Array.from(this.querySelectorAll('[data-leather-pickup]'))
        .sort((a, b) => Number(a.dataset.leatherIndex) - Number(b.dataset.leatherIndex));
      this.currentStart = null;
      if (!this.panels.length) return;
      this.refresh = () => this.update();
      this.selectBlock = (event) => {
        const index = this.panels.findIndex(panel => panel.dataset.leatherPickup === event.detail.blockId);
        if (index < 0) return;
        this.editorIndex = index;
        this.update();
      };
      this.deselectBlock = () => {
        this.editorIndex = null;
        this.update();
      };
      window.addEventListener('pageshow', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', this.selectBlock);
        this.addEventListener('shopify:block:deselect', this.deselectBlock);
      }
      this.update();
    }

    update() {
      clearTimeout(this.timer);
      const now = Date.now();
      const day = Math.floor((now + JST) / DAY);
      const count = this.panels.length;
      const dailyIndex = ((day * 4 % count) + count) % count;
      const index = this.editorIndex == null ? dailyIndex : this.editorIndex;
      if (this.currentStart !== index) {
        const ordered = this.panels.slice(index).concat(this.panels.slice(0, index));
        ordered.forEach((panel, i) => { panel.hidden = i >= 4; });
        // DOM order follows the displayed order, including wraparound, so keyboard navigation agrees.
        this.grid.append(...ordered);
        this.currentStart = index;
      }
      // A sleeping tab can miss midnight. pageshow and visibilitychange also refresh from the current clock.
      if (this.editorIndex == null) {
        this.timer = setTimeout(this.refresh, (day + 1) * DAY - JST - now + 50);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      window.removeEventListener('pageshow', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      this.removeEventListener('shopify:block:deselect', this.deselectBlock);
      this.editorIndex = null;
    }
  }

  customElements.define('cm-leather-pickup', LeatherPickup);
})();
